import { render, staticRenderFns } from "./Bridge.vue?vue&type=template&id=6b2d58a4&"
import script from "./Bridge.vue?vue&type=script&lang=js&"
export * from "./Bridge.vue?vue&type=script&lang=js&"
import style0 from "./Bridge.vue?vue&type=style&index=0&id=6b2d58a4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports